import {
  deliveryGetCreatePreconditionMethods,
  deliveryInfoMethods,
  deliveryConfigGetMethods,
  deliverySystemGetWaterMarkMethods,
} from './service-delivery'
import { getAuthData, canPreview } from './service-auth'

export const LINK_SHARE_PREPARATION = {
  data() {
    return {
      waterMarkIsOpen: null,
      linkShareFormData: null,
    }
  },
  methods: {
    newLinkShareDataProcessing() {
      // 新建链接数据处理
      const { neid, nsid } = this.currentData
      const linkShareGetCreatePreconditionNeedParams = {
        neid,
        nsid,
        isCreate: true,
        authData: this.authData(),
        type: {
          canPreview: this.canPreview(),
          canUpload: this.canUpload(),
        },
      }
      this.loading = true
      deliveryGetCreatePreconditionMethods(linkShareGetCreatePreconditionNeedParams)
      // 导入先决条件拼装好的数据,交给水印接口做最后拼装
        .then((createRes) => deliverySystemGetWaterMarkMethods(this.canAddWaterMark, createRes))
        .then((waterMarkRes) => {
          // 水印服务开启：需要继续调用水印详细配置
          if (waterMarkRes.startWatermark === true) {
            // 水印服务开启情况下,将水印详情导入进行最后的拼装，走入下一个then
            return deliveryConfigGetMethods(this.canAddWaterMark, waterMarkRes)
          }
          // 水印服务没有开启：不再进行水印导入，打开新建窗口
          this.shareLink.otherData = {
            waterMarkIsOpen: false,
            linkShareFormData: waterMarkRes.results,
          }
          this.shareLink.showDialog = true
          this.loading = false
          return false
        })
        .then((waterConfigRes) => {
          // 水印服务开启情况下,将水印详情导入进行最后的拼装,拿到的数据
          if (waterConfigRes) {
            this.waterMarkIsOpen = true
            this.linkShareFormData = waterConfigRes.results
            // 当基础接口调用完毕后,打开dialog
            this.loading = false
            this.shareLink.otherData = {
              waterMarkIsOpen: true,
              linkShareFormData: waterConfigRes.results,
            }
            this.shareLink.showDialog = true
          }
        })
        .catch((err) => {
          this.loading = false
          if (err.response.config.url.indexOf('get_create_precondition') > -1 && err.response.status === 403) {
            window.$toast.simpleShow((err.response
              && err.response.data
              && err.response.data.message) || err.message, 'error')
          }
          if (err.response && err.response.status === 409) {
            window.$toast.simpleShow((err.response.data
              && err.response.data.message) || err.message, 'error')
          }
        })
    },
    canPreview() {
      // 计算当前文件类型能否预览
      // 当为软航服务器的时候，外链按钮是不应该禁用的，所以增加了状态来判断是否为外链组件调用的该方法
      const sysConfig = {}
      window.store.state.lenovoData.LenovoData.custominfo.forEach((val) => {
        sysConfig[val.name] = val.value
      })
      const { mime_type: mineType } = this.currentData
      return canPreview(mineType, sysConfig)
        || (this.currentData.is_dir)
    },
    canUpload() {
      // 计算当前文件类型能否上传
      return this.currentData.is_dir
    },
    authData() {
      // 计算原子权限
      const { access_mode: accessMode } = this.currentData
      return getAuthData(accessMode)
    },
  },
  computed: {
    canAddWaterMark() {
      // 计算当前文件类型能否添加水印服务
      const metaData = this.currentData
      return /\.doc|docx|exl|exls|ppt|pptx|xls|xlsx|wps|wpt|dps|dpt|et|eet|pdf|psd|jpg|tif|gif|jpeg|eps|ai|bmp|tiff|png/.test(metaData.mime_type) || metaData.is_dir
    },
  },
}
